import { ToppingsEnum, TOPPING_IMAGES } from '../toppings_defs';
import './guess-box.css';

const HOT_DOG_COLOR = '#BB4F26';

interface GuessBoxProps {
    topping: ToppingsEnum | undefined;
    isUserInput?: boolean;
}

function GuessBox(props: GuessBoxProps) {
    const { topping, isUserInput } = props;
    return (
        <div
            className="guess-box"
            style={{
                backgroundColor: isUserInput ? 'lightcyan' : HOT_DOG_COLOR,
            }}
        >
            {topping ? (
                <div className="box-content">
                    <img
                        src={TOPPING_IMAGES[topping]}
                        alt={topping}
                        className="box-icon"
                    />
                    <div className="box-label">{topping[0]}</div>
                </div>
            ) : isUserInput ? (
                ''
            ) : (
                '?'
            )}
        </div>
    );
}

export default GuessBox;
